function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none",
  viewBox: "0 0 20 16",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 4h-9v2h9zm0 8h-9v2h9zM3.54 8 0 4.46l1.41-1.41 2.12 2.12L7.77.93l1.41 1.41zm0 8L0 12.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-mobility-options.svg";
export { SvgComponent as ReactComponent };